<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
              :src="Core.Session.AuthUser.avatar"
              class="img-avatar"
              :alt="Core.Session.AuthUser.displayName" />
    </template>
    <template slot="dropdown">
        <b-dropdown-header
                v-if="Core.Session.AuthUser.isAuth()"
                tag="div"
                class="text-center">
          <strong>{{Core.Session.AuthUser.displayName}}</strong>
        </b-dropdown-header>
        <b-dropdown-item
                v-if="Core.Session.AuthUser.isAuth()"
                @click="$router.push(Core.Definition.getDefinition('/compte/profil'))">
                <i class="fa fa-user" /> {{Core.Definition.getDefinition('Mon profil')}}
        </b-dropdown-item>
      <b-dropdown-divider v-if="Core.Session.AuthUser.isAuth()" />
      <b-dropdown-item v-if="Core.Session.AuthUser.isAuth()" @click="logOut"><i class="fa fa-lock" /> {{Core.Definition.getDefinition('Déconnexion')}}</b-dropdown-item>
      <b-dropdown-item v-if="!Core.Session.AuthUser.isAuth()" @click="logOut"><i class="fa fa-user" /> {{Core.Definition.getDefinition('Connexion')}}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
  import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
  export default {
    name: 'HeaderDropdownAccount',
    components: {
      AppHeaderDropdown
    },
    data: () => {
      return {
        Core: window.Core,
        itemsCount: 42
      }
    },
    methods: {
      logOut() {
        window.Core.Session.logOut()
        this.$router.push(window.Core.Definition.getDefinition('/connexion'))
          location.reload()
      }
    }
  }
</script>

